<mat-grid-tile-header *ngIf="porteur.nbDemandes && porteur.nbDemandes!==0" matTooltip="Demandes en cours" matTooltipPosition="right">
  <mat-badge [matBadge]="porteur.nbDemandes" matBadgeSize="large" class="badge-color"></mat-badge>
</mat-grid-tile-header>

<div id="content">
  <h3 class="font-normal">N° UTILISATEUR : {{ porteur.numPorteur }}</h3>
  <h3>{{ porteur.porteur }}</h3>
  <h3>N° casier : {{ porteur.casier && porteur.casier != '' ? porteur.casier : "Non renseigné"}}</h3>
  <h3 class="font-normal">Compte : {{porteur.codeClient + '/' + porteur.codeService}}</h3>
</div>

<mat-grid-tile-footer class="flex justify-between">
  <div (click)="showDetails()">
    <mat-icon>visibility</mat-icon>
    <div class="font-bold">Voir</div>
  </div>
  <div (click)="delete()">
    <mat-icon>delete</mat-icon>
    <div class="font-bold">Retirer</div>
  </div>
</mat-grid-tile-footer>
